<template>
    <div id="___gatsby">
        <div tabindex="-1" id="gatsby-focus-wrapper" style="outline: none">
            <div>
                <div class="header">
                    <NavBar v-if="!this.GLOBAL.isMobile"></NavBar>
                    <MobileTopNavBar v-if="this.GLOBAL.isMobile"></MobileTopNavBar>
                </div>
                <!-- NavBar 固定定位后脱离文档流，非首页需要此占位块撑开顶部空间 -->
                <div v-if="!this.GLOBAL.isMobile && !isHomePage" class="navbar-placeholder"></div>
                <router-view></router-view>
                <IndexFooter v-if="!this.GLOBAL.isMobile"></IndexFooter>
            </div>
        </div>
    </div>
</template>

<script>
import IndexFooter from '../components/indexfooter.vue'
import NavBar from '../components/navBar.vue'
import MobileTopNavBar from "@/components/mobileTopNavBar.vue";

export default {
    components: {
        NavBar,
        IndexFooter,
        MobileTopNavBar,
    },
    computed: {
        isHomePage() {
            return this.$route && (this.$route.path === '/' || this.$route.path === '/home')
        }
    }
}
</script>

<style lang="less" scoped>

.navbar-placeholder {
    height: 70px;
}

</style>
